"use client";

import { VideoSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedVideoSection from "../Components/GeneratedVideoSection";

const Video: FC<VideoSectionProps> = (props) => {
  return <GeneratedVideoSection {...props} />;
};

export default Video;
